<!-- 首页 -->
<template>
  <div :class="['teacherDetail', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title titleName="教师介绍" :bcColor="'#fff'" :zIndex="1000"></common-title>
    <div class="teachercontent" v-show="teacher.publicName">
      <div class="up">
        <div class="up_lt">
          <img :src="teacher.topicWebHead" alt="" />
        </div>
        <div class="up_rt">
          <h2>{{ teacher.publicName }}</h2>
          <p>{{ teacher.teachMainModule }}</p>
          <div class="discuss" v-if="this.$route.query.source !== 'branch'" @click="toEvaluate">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/zan.png" alt="" />
            <span>评价</span>
          </div>
        </div>
      </div>
      <div class="middle" v-if="teacher.teachFeature">
        <div class="spe"><em></em><span>授课特色：</span></div>
        <p>
          {{ teacher.teachFeature }}
        </p>
      </div>
      <div class="middle" v-if="teacher.teacherBrief">
        <div class="spe"><em></em><span>教师简介：</span></div>
        <p>
          {{ teacher.teacherBrief }}
        </p>
      </div>
      <div class="video" v-show="teacher.auditionVideo && $route.query.source !== 'branch'">
        <div class="spe"><em></em><span>试听视频课</span></div>
        <div class="videobox">
          <div id="player"></div>
        </div>
      </div>
    </div>
    <div class="teacher" v-if="courseList.length > 0 && !distributorId">
      <div class="spe"><em></em><span>老师课程</span></div>
      <ul class="courseList">
        <li v-for="(item, keys) in courseList" :key="keys">
          <HotCourseCard :item="item" :key="keys" />
        </li>
      </ul>
    </div>
    <EmptyData v-show="!teacher.publicName && !distributorId" emptyName="noEvaluation" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { reqTeacherInfo, reqTeacherProduct } from '@/api/teacherInfo';
import { reqProducts } from '@/api/home';
import { RECORD_SITE_ID } from '@/utils/common';
import loadJS from 'load-js';
import wx from 'weixin-js-sdk';
import {deepCopy} from "@/utils/tools";

export default {
  data() {
    return {
      productIds: [], //教师关联产品id
      courseList: [], //课程
      teacher: [], //师资介绍详情
      player: null,
      distributorId: localStorage.getItem('distributorId')
    };
  },
  components: {
    CommonTitle,
    HotCourseCard,
    EmptyData,
  },
  computed: {
    ...mapState(['userInfo']),
  },

  created() {},
  mounted() {
    this.getTeacherInfo();
    this.getTeacherProduct();
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
  destroyed() {
    this.player && this.player.destroy();
  },
  methods: {
    // 请求课程id集合
    async getRecommend() {
      if (this.$route.query.source === 'branch') return;
      const productIds = this.productIds;
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const allProductIds = [];
      productIds.forEach((id) => {
        allProductIds.push(id);
      });
      const p1 = reqProducts(productIds, endPoint);
      Promise.all([p1]).then((result) => {
        const res = result[0];
        this.courseList = this.resetCourse(res?.data || []);
      });
    },
    resetCourse(majorCourseList) {
      majorCourseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return majorCourseList;
    },
    //获取产品id
    async getTeacherProduct() {
      let teacherId = this.$route.query.teacherId * 1;
      const res = await reqTeacherProduct(teacherId);
      if (res.code === 0 && res.data) {
        let resData = res.data;
        resData.forEach((item) => {
          this.productIds.push(item);
        });
        this.getRecommend();
      }
    },
    //获取教师详情
    async getTeacherInfo() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      let teacherId = this.$route.query.teacherId * 1;
      const res = await reqTeacherInfo(teacherId);
      if (res.code === 0 && res.data) {
        this.teacher = res.data;
        this.initData();
      }
      this.$toast.clear();
    },
    //试听课程
    initData() {
      document.getElementById('player').innerHTML = '';
      // CC的录播视频
      loadJS([
        {
          async: false,
          url: `https://p.bokecc.com/player?siteid=${RECORD_SITE_ID}&newversion=true`,
        },
      ]).then(() => {
        this.setPlayerCallBack();
      });
    },
    setPlayerCallBack() {
      if (window.createCCH5Player) {
        this.createPlayer();
      } else {
        window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      }
      window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
    },
    onCCH5PlayerLoaded() {
      window.ccH5PlayerJsLoaded = true;
      this.createPlayer();
    },
    createPlayer() {
      if (this.teacher.auditionVideo && this.teacher.auditionVideoCC) {
        const { auditionVideo, auditionVideoCC } = this.teacher;
        this.player = window.createCCH5Player({
          vid: auditionVideoCC,
          siteid: RECORD_SITE_ID,
          autoStart: true,
          width: '100%',
          height: '100%',
          showFullScreenBtn: false,
          allowFullScreen: false,
          parentNode: document.getElementById('player'),
          vc: auditionVideo * 1, //授权码 int类型
        });
      } else {
        // this.$toast('视频地址出错,请稍后重试～');
      }
    },
    toEvaluate() {
      const { teacherId, productId } = this.$route.query;
      if (!this.userInfo.id && this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();

          params.forEach((item) => {
            const [key, value] = item.split('=');
            console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
        } else {
          url = `${domain}`;
        }
        const redirctUrl = encodeURIComponent(
          `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
        return;
      }
      if (!this.userInfo.id && this.$root.$data.isApp) {
        this.$sendToApp('login');
        return;
      }
      if (!this.userInfo.id) {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
        return;
      }

      this.$router.push({
        path: '/evaluation',
        query: { teacherId, entryType: 3, courseId: productId },
      });
    },
     getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .commonTitle {
  position: fixed;
  right: 0;
  left: 0;
  width: 750px;
  margin: 0 auto;
}
.teacherDetail {
  width: 750px;
  height: 100vh;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #fff;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
}
.teachercontent {
  padding: 40px 40px 0;
  padding-bottom: 20px;
  .spe {
    display: flex;
    align-items: center;
    em {
      display: block;
      width: 8px;
      height: 24px;
      background: #ff7f41;
      border-radius: 4px;
    }
    span {
      display: block;
      margin-left: 12px;
      color: #323232;
      font-weight: 500;
      font-size: 36px;
    }
  }
  .up {
    display: flex;
    justify-content: space-between;
    margin-bottom: 70px;
    .up_lt {
      position: relative;
      width: 302px;
      height: 318px;
      background: linear-gradient(180deg, #fef9f4 0%, #fcc495 100%);
      border-radius: 32px;
      img {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        display: block;
        width: 220px;
        height: 326px;
        margin: 0 auto;
      }
    }
    .up_rt {
      position: relative;
      width: 344px;
      h2 {
        margin-bottom: 8px;
        color: #333;
        font-weight: 500;
        font-size: 48px;
      }
      p {
        display: -webkit-box;
        overflow: hidden;
        color: #666;
        font-weight: 400;
        font-size: 28px;
        line-height: 48px;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .discuss {
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 126px;
        height: 46px;
        background: #ff7f41;
        border-radius: 24px;
        img {
          width: 24px;
          height: 24px;
        }
        span {
          padding-left: 4px;
          color: #fff;
          font-weight: 500;
          font-size: 24px;
          line-height: 34px;
        }
      }
    }
  }
  .middle {
    p {
      margin-top: 14px;
      margin-bottom: 40px;
      color: #666;
      font-weight: 400;
      font-size: 28px;
      line-height: 48px;
    }
  }
  .video {
    .videobox {
      height: 376px;
      margin-top: 20px;
      margin-bottom: 40px;
      border-radius: 16px;
      #player {
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
.teacher {
  .spe {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 40px;
    em {
      display: block;
      width: 8px;
      height: 24px;
      background: #ff7f41;
      border-radius: 4px;
    }
    span {
      display: block;
      margin-left: 12px;
      color: #323232;
      font-weight: 500;
      font-size: 36px;
    }
  }
}
.courseList::-webkit-scrollbar {
  display: none;
}
.courseList {
  box-sizing: border-box;
  width: 100%;
  min-height: 98px;
}
.courseList > li {
  position: relative;
  width: 679px;
  margin: 0 auto;
  margin-bottom: 18px;
  background: $bgWhite;
  border-radius: 7px;
  .liveImg {
    position: absolute;
    top: 0;
    right: 0;
    width: 140px;
    height: 50px;
    border-radius: 0 16px 0 32px;
  }
}
</style>
